/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { BtnMenuHome } from "../BtnMenuHome";
import { BtnMenuMore } from "../BtnMenuMore";
import { BtnMenuRequest } from "../BtnMenuRequest";
import { BtnMenuSend } from "../BtnMenuSend";
import "./style.css";

export const MainMenu = ({
  className,
  color = "black",
  btnMenuHomeFluentHome = "/img/fluent-home-12-filled.svg",
  btnMenuSendMingcuteSendPlane = "/img/mingcute-send-plane-line.svg",
  btnMenuRequestProfits = "/img/profits-1.svg",
  btnMenuMoreRegularMenuDots = "/img/regular-menu-dots-1.svg",
}) => {
  return (
    <div className={`main-menu ${className}`}>
      <div className="content">
        <BtnMenuHome
          color={color}
          className="design-component-instance-node-2"
          fluentHome={btnMenuHomeFluentHome}
          status="on"
        />
        <BtnMenuSend
          color={color}
          className="design-component-instance-node-2"
          mingcuteSendPlane={btnMenuSendMingcuteSendPlane}
          status="off"
        />
        <BtnMenuRequest
          color={color}
          className="design-component-instance-node-2"
          profits={btnMenuRequestProfits}
          status="off"
        />
        <BtnMenuMore
          color={color}
          className="design-component-instance-node-2"
          regularMenuDots={btnMenuMoreRegularMenuDots}
          status="off"
        />
      </div>
    </div>
  );
};

MainMenu.propTypes = {
  btnMenuHomeFluentHome: PropTypes.string,
  btnMenuSendMingcuteSendPlane: PropTypes.string,
  btnMenuRequestProfits: PropTypes.string,
  btnMenuMoreRegularMenuDots: PropTypes.string,
};
